import React, { Component, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './lib/useTheme';
import ServicesProvider from './providers/ServicesProvider';
import SubscriptionProvider from './providers/SubscriptionProvider';
import UIProvider from './providers/UIProvider';
import AppRoutes from './router';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this._retryCount = 0;
    this._retryTimer = null;
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error('[ErrorBoundary]', error?.message);
    if (this._retryCount < 3) {
      this._retryCount++;
      this._retryTimer = setTimeout(() => {
        this.setState({ hasError: false });
      }, 400 * this._retryCount);
    }
  }

  componentWillUnmount() {
    if (this._retryTimer) clearTimeout(this._retryTimer);
  }

  render() {
    if (this.state.hasError) {
      if (this._retryCount <= 3) {
        return (
          <div style={{ minHeight: '100vh', background: '#1a1a2e', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ width: 40, height: 40, border: '3px solid rgba(201,168,76,0.2)', borderTopColor: '#C9A84C', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          </div>
        );
      }
      return (
        <div style={{ minHeight: '100vh', background: '#1a1a2e', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, padding: 40 }}>
          <p style={{ fontSize: 18, fontWeight: 600, color: '#fff' }}>Maestro hit a snag</p>
          <p style={{ fontSize: 14, color: '#999', maxWidth: 400, textAlign: 'center', lineHeight: 1.5 }}>
            Something unexpected happened. A quick refresh usually fixes it.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{ marginTop: 8, padding: '10px 24px', borderRadius: 8, background: '#C9A84C', color: '#1a1a2e', fontWeight: 700, fontSize: 14, border: 'none', cursor: 'pointer' }}
          >
            Refresh
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function DismissSplash() {
  useEffect(() => {
    const splash = document.getElementById('maestro-splash');
    if (!splash) return;
    requestAnimationFrame(() => {
      splash.classList.add('fade-out');
      splash.addEventListener('transitionend', () => splash.remove(), { once: true });
    });
  }, []);
  return null;
}

export default function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <ServicesProvider>
          <SubscriptionProvider>
            <UIProvider>
              <BrowserRouter>
                <AppRoutes />
                <DismissSplash />
              </BrowserRouter>
            </UIProvider>
          </SubscriptionProvider>
        </ServicesProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
